<template>
  <div id="app" class="flex  bg-pampas flex-col">
    <section
      v-if="!loginPage"
      class="
        mobile-menu
        fixed
        md:hidden
        print:hidden
        inset-x-0
        bottom-0
        z-50
        bg-white
        shadow-lg
        border

      "
    >
      <div class="flex justify-between ">
        <div
          class="w-full justify-center inline-block text-center pt-2 pb-1"
          v-for="(table, index) in $root.cache.tables"
          v-if="table.location == 1"
          :key="table.id"
        >
          <template v-if="table.url">
            <router-link :to="{ name: table.url, params: { index } }">
              <vk-icon
                class="text-black"
                ratio="1"
                style="color:black"
                :icon="table.icon"
              ></vk-icon>
              <span class="tab tab-home text-black block text-xs">{{
                table.name
              }}</span>
            </router-link>
          </template>
          <template v-else>
            <router-link
              :to="{ name: 'list', params: { index, table: table.table } }"
            >
              <vk-icon
                ratio="1"
                style="color:black"
                class="text-black"
                :icon="table.icon"
              ></vk-icon>
              <span class="tab tab-home text-black block text-xs">{{
                table.name
              }}</span>
            </router-link>
          </template>
        </div>
      </div>
    </section>
    <BottomMessage />
    <AppHeadNavbar
      :favorites="favorites"
      :userName="userName"
      :sidebarNotes="sidebarNotes"
      :notifications="notifications"
      :notificationCount="notificationCount"
      :userID="userID"
      v-if="theme == 'head_navbar'"
    />
    <DefaultTheme
      :favorites="favorites"
      :userName="userName"
      :sidebarNotes="sidebarNotes"
      :notificationCount="notificationCount"
      :notifications="notifications"
      :userID="userID"
      v-else
    />
  </div>
</template>
<script>
import AuthService from "./services/auth";
import Pusher from "pusher-js";
import AppHeadNavbar from "./App.HeadNavbar.vue";
import DefaultTheme from "./App.Default.vue";
import EventBus from "./components/Ui/EventBus";
import BottomMessage from "./components/BottomMessage.vue";
import Config from "./config";
import http from "./services/http";
export default {
  components: {
    BottomMessage,
    AppHeadNavbar,
    DefaultTheme,
  },
  data() {
    return {
      messages: [],
      mobileShow: false,
      menuNameShow: true,
      messagesType: "primary",
      loginPage: true,
      userName: null,
      userID: null,
      loading: true,
      sidebarProfile: false,
      themeBackground: null,
      searchValue: null,
      routeSelected: this.$route.params.index,
      searchTable: "leads",
      notificationCount: 0,
      notifications: [],
      sidebarNotes: [],
      favoriteShow: false,
      sidebarNoteShow: false,
      show: false,
      isOpen: false,
      notificationList: false,
      results: [],
      search: "",
      themeStyle: 1,
      theme: "default",
      themeDark: false,
      themeMenuShow: 250,
      isLoading: false,
      favorites: [],
      mutedKeywords: JSON.parse(localStorage.getItem("mutedKeywords")) || [],
      arrowCounter: -1,
    };
  },
  created() {
    Notification.requestPermission();
    this.loading = false;
    this.checkLoginPage();
    this.themeBackground = localStorage.themeBackground;
    if (localStorage.themeStyle) {
      this.themeStyle = localStorage.themeStyle;
    }
    if (localStorage.themeDark) {
      this.themeDark = localStorage.themeDark;
    }
    if (localStorage.theme) {
      this.theme = localStorage.theme;
    }

    this.userName = localStorage.userName;
    this.userID = localStorage.userId;
    const sidebarNoteShow = localStorage.getItem("sidebarNoteShow");
    if (sidebarNoteShow == "true") {
      this.sidebarNoteShow = true;
    }
    const favoriteShow = localStorage.getItem("favoriteShow");
    if (favoriteShow == "true") {
      this.favoriteShow = true;
    }
    http.getSidebarNotes().then((resp) => {
      this.sidebarNotes = resp.data;
    });
    this.getFavorites();
    window.addEventListener("keydown", function(event) {
      if (event.key === "k" && event.ctrlKey === true) {
        EventBus.$emit("topSearchFocus");
      }
    });
  },
  watch: {
    $route(to) {
      if (to.meta.location == 1) {
        this.routeSelected = to.params.index;
      }
    },
    searchTable() {
      this.searchSubmit();
    },
    searchValue(data) {
      if (data == "") {
        setTimeout(() => {
          this.show = false;
        }, 5000);
      }
    },
  },
  methods: {
    unmuteNotification(keyword) {
      this.mutedKeywords = this.mutedKeywords.filter(item => item !== keyword);
      localStorage.setItem("mutedKeywords", JSON.stringify(this.mutedKeywords));
    },
    muteNotification(keyword) {
      if (!this.mutedKeywords.includes(keyword)) {
        this.mutedKeywords.push(keyword);
        localStorage.setItem("mutedKeywords", JSON.stringify(this.mutedKeywords));
      }
    },
    
    // Bildirimin sessize alınmış olup olmadığını kontrol eden fonksiyon
    isNotificationMuted(notification) {
      return this.mutedKeywords.some(keyword => 
        (notification.body && notification.body.includes(keyword)) ||
        (notification.leadName && notification.leadName.includes(keyword)) ||
        (notification.title && notification.title.includes(keyword))
      );
    },
    reload() {
      EventBus.$emit("reflesh", true);
    },
    getFavorites() {
      http.getFavorites().then((resp) => {
        this.favorites = resp.data;
      });
    },
    removeFavorite(id) {
      http.removeFavorite(id).then(() => {
        this.getFavorites();
      });
    },

    sidebarNoteToggle() {
      this.sidebarNoteShow = !this.sidebarNoteShow;
      localStorage.sidebarNoteShow = this.sidebarNoteShow;
    },
    favoriteToggle() {
      this.favoriteShow = !this.favoriteShow;
      localStorage.favoriteShow = this.favoriteShow;
    },
    logout() {
      AuthService.logout().then(() => {
        this.$router.push("logout");
      });
    },
    checkLoginPage() {
      if (this.$route.meta.requiresAuth == false) {
        this.loginPage = true;
      } else {
        this.loginPage = false;
      }
    },
    notifySend(data) {
      Notification.requestPermission(function(result) {
        if (result === "granted") {
          navigator.serviceWorker.ready.then(function(registration) {
            registration.showNotification(data.title, {
              body: data.body,
            });
          });
        }
      });
    },
    onChange() {
      // Let's warn the parent that a change was made
      this.$emit("input", this.search);
      // Let's  our flat array
      this.filterResults();
      this.isOpen = true;
    },
    setResult(result) {
      this.search = result;
      this.isOpen = false;
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.searchValue = this.results[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
    },
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  mounted() {
    this.$root.isMobile();
    if (this.userID > 0) {
      this.pusher = new Pusher(Config.PUSHER_APP_KEY, {
        wsHost: Config.PUSHER_WS_HOST,
        wsPort: Config.PUSHER_WS_PORT,
        wssPort: Config.PUSHER_WSS_PORT,
        forceTLS: false,
        encrypted: false,
        disableStats: true,
        enabledTransports: ["wss", "ws"],
      });

      let excelId = localStorage.excelUploadId;

      EventBus.$on("newMutedKeywords", () => {


        this.mutedKeywords =  JSON.parse(localStorage.getItem("mutedKeywords"));
        

      });
      EventBus.$on("excelUploadId", (excelUploadId) => {
        this.pusher
          .subscribe(
            "excelupload_" + Config.PUSHER_CHNL_ID + "_" + excelUploadId
          )
          .bind("message", (message) => {
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "upload",
              count: message,
              title: "Veriler yüklendi",
              body: " (" + message[0] + ") tane kayıt başarılı olarak yüklendi",
            });
          });
      });

      this.pusher
        .subscribe("excelupload_" + Config.PUSHER_CHNL_ID + "_" + excelId)
        .bind("message", (message) => {
          EventBus.$emit("bottomMessage", {
            open: true,
            type: "upload",
            count: message,
            title: "Veriler yüklendi",
            body: " (" + message[0] + ") tane kayıt başarılı olarak yüklendi",
          });
        });

      this.pusher
        .subscribe("notification_" + Config.PUSHER_CHNL_ID + "_" + this.userID)
        .bind("message", (message) => {
       


          if (!this.isNotificationMuted(message)) {
            this.notificationCount++;
            EventBus.$emit("notificationReflesh");
          if (message.leadName) {
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "info",
              title: message.leadName,
              body: message.body,
              url: { label: "Detay", url: "/leadDetail/" + message.lead_id },
            });
          } else {
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "info",
              title: message.title,
              body: message.body,
            });
          }
       

          this.notifySend({ title: message.title, body: message.body });
        }

        });
    }
    this.routeSelected = this.$router.history.current.params.index || 0;
    this.$on("loading", (data) => {
      this.loading = data;
    });
    EventBus.$on("loading", (data) => {
      this.loading = data;
    });
    this.$on("logon", () => {
      this.checkLoginPage();
    });
    EventBus.$on("userName", (e) => {
      this.userName = e;
    });
    EventBus.$on("themeBackground", (e) => {
      this.themeBackground = e;
    });
    EventBus.$on("themeStyle", (e) => {
      this.themeStyle = e;
    });

    EventBus.$on("clickShowLog", (e) => {
      console.log(e.data, "click log geldi");
    });

    EventBus.$on("themeDark", (e) => {
      this.themeDark = e;
    });
    EventBus.$on("themeMenuShow", (e) => {
      this.themeMenuShow = e;
    });
    EventBus.$on("sidebarNoteShow", (e) => {
      this.sidebarNoteShow = e;
    });
    EventBus.$on("favoritesLoad", () => {
      this.getFavorites();
    });
  },
};
</script>
